<template>
  <div id="app">    
      <router-view/>
      <!--// 알림 팝업 -->
      <pop-common-alert ref="alert" />
      <pop-common-confirm ref="confirm"/>
  </div>
</template>

<script>
import EventBus from "@/js/eventBus.js"
export default {
  name: 'App',
  
  created() {
    //  let thos = this;

    EventBus.$on("showAlert", (payload) => {
      // thos.$refs.alert.show(thos, payload.msg, payload.onConfirm);
      this.$refs.alert.show( payload.title, payload.msg, payload.onConfirm, payload.confirmText);
    });
    EventBus.$on("closeAlert", (payload) => {
      this.$refs.alert.onClose();
    });
    EventBus.$on("showConfirm", (payload) => {
      // thos.$refs.confirm.show(thos, payload.msg, payload.onConfirm, payload.onCancel);
      this.$refs.confirm.show(payload.msg, payload.onConfirm, payload.onCancel, payload.confirmText, payload.cancelText);
    });
    EventBus.$on("closeConfirm", (payload) => {
      this.$refs.confirm.onClose();
    });
    EventBus.$on("close", (payload) => {
      this.$refs.alert.onClose();
      this.$refs.confirm.onClose();
    });
  }
}
</script>

<style>
  @import url('./assets/css/style.css');
</style>



// WEBPACK FOOTER //
// src/App.vue